import { render, staticRenderFns } from "./PsychiatricScreeningPhase.vue?vue&type=template&id=7e9ea9bf&scoped=true&"
import script from "./PsychiatricScreeningPhase.vue?vue&type=script&lang=js&"
export * from "./PsychiatricScreeningPhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9ea9bf",
  null
  
)

export default component.exports